import React from 'react';
import { createPortal } from 'react-dom';

class MapControl extends React.PureComponent {
  constructor(props) {
    super(props)
    this.controlDiv = document.createElement('div');
    if (this.props.map) {
      this.controlIndex = this.props.map.controls[this.props.position].length;
      this.props.map.controls[this.props.position].push(this.controlDiv);
    }
    this.props.className && this.controlDiv.classList.add(this.props.className);
  }
  componentDidUpdate() {
    if (this.controlIndex == null && this.props.map) {
      this.controlIndex = this.props.map.controls[this.props.position].length;
      this.props.map.controls[this.props.position].push(this.controlDiv);
    }
  }
  componentWillUnmount() {
    if (this.controlIndex != null) {
      this.props.map.controls[this.props.position].removeAt(this.controlIndex);
    }
  }
  render() {
    return (createPortal(this.props.children, this.controlDiv));
  }
};

export default MapControl
